import React from 'react';
import PropTypes from 'prop-types';
import TagList from '../TagList/TagList.jsx';

const EventItem = ({name, image = '', image_alt = '', url, startDate, endDate, description, tags, targetGroups}) => {
    return (
        <li className="tw-mb-4 tw-flex tw-items-center tw-justify-between tw-bg-white tw-px-4 tw-py-4 dark:tw-bg-veryBlack ">
            <a href={url} className="tw-group tw-flex tw-flex-col tw-gap-4 tw-no-underline md:tw-flex-col lg:tw-flex-row">
                {image && (
                    <img src={image} className="tw-aspect-3/2 tw-w-1/2 tw-min-w-[280px] tw-object-cover tw-object-center tw-align-top  lg:tw-min-w-[350px]" alt={image_alt} />
                )}
                <div className="tw-shrink">
                    <p className="tw-mb-0 tw-text-s tw-font-medium tw-text-black dark:tw-text-white">
                        {new Date(startDate).toLocaleDateString('pl-PL', {day: 'numeric', month: 'long', year: 'numeric'})}
                        {new Date(endDate).getTime() !== 0 && <span> - {new Date(endDate).toLocaleDateString('pl-PL', {day: 'numeric', month: 'long', year: 'numeric'})}</span>}
                    </p>
                    <h3 className="tw-my-3 tw-line-clamp-3 tw-text-lg group-hover:tw-underline md:tw-line-clamp-2">{name}</h3>
                    <p className="tw-line-clamp-5 tw-text-black dark:tw-text-white" dangerouslySetInnerHTML={{__html: description}}></p>
                    <TagList tags={[...tags, ...targetGroups]} />
                </div>
            </a>
        </li>
    );
};

EventItem.propTypes = {
    name: PropTypes.string.isRequired,
    image: PropTypes.string,
    image_alt: PropTypes.string,
    url: PropTypes.string.isRequired,
    startDate: PropTypes.string.isRequired,
    endDate: PropTypes.string,
    description: PropTypes.string,
    tags: PropTypes.array,
    targetGroups: PropTypes.array,
};

export default EventItem;
